module.exports = __webpack_public_path__ + "img/arrow_forward_circle.9a2c315d.svg";